export class EventEmitter {
  private listeners: { [name: string]: Array<(data: any) => any> } = {};

  on(name: string, fn: (data: any) => any): () => void {
    if (!this.listeners[name]) {
      this.listeners[name] = [];
    }
    const index = this.listeners[name].push(fn) - 1;
    return () => {
      delete (this.listeners[name][index]);
    };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  emit(name: string, data?: any): any {
    const listeners = this.listeners[name] || [];
    return listeners.reduce((value, listener) => {
      const result = listener(value);
      return result ? result : value;
    }, data);
  }

}
